<!--
 * @Description: 部门账号 新增编辑弹出层
 * @Author: ma.cq
 * @Date: 2020-03-31 10:28:41
 * @LastEditors: YY
 * @LastEditTime: 2023-11-10 18:12:33
 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visiable"
    width="800px"
    @close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="类型">部门账号</el-form-item>
      <el-form-item v-if="isEdit" label="所属主账户">
        {{form.rootAccount.userName}}
      </el-form-item>
      <el-form-item v-else label="所属主账户" prop="rootAccount">
        <el-select
          v-model="form.rootAccount"
          filterable
          remote
          reserve-keyword
          clearable
          placeholder="请输入客户名称关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          value-key="accountId">
          <el-option
            v-for="item in rootAccountList"
            :key="item.accountId"
            :label="item.customerName"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子账户用户名" prop="username">
        <el-input v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="psw">
        <psw-input v-model="form.psw"></psw-input>
      </el-form-item>
      <el-form-item label="支付密码" prop="paypsw">
        <psw-input v-model="form.paypsw"></psw-input>
      </el-form-item>
      <el-form-item label="权限" prop="power">
        <el-checkbox-group v-model="form.power" @change="powerChange">
          <el-checkbox v-for="item in powers" :key="item.value" @change="powerItemChange(item)" :label="item.value">{{item.label}} </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import PswInput from '@/components/pswInput'
import { checkPhone, checkPassword } from '@/common/verify.js'
import { base64Text } from '@/common/base64'

export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  components: { PswInput },
  data () {
    return {
      visiable: false,
      form: {
        rootAccount: '',
        username: '',
        phone: '',
        psw: '',
        paypsw: '',
        power: []
      },
      loading: false,
      rules: {
        rootAccount: [
          { required: true, message: '请选择主账户' }
        ],
        username: [
          { required: true, message: '请输入子账户用户名' }
        ],
        phone: [
          { required: true, message: '请输入手机号' },
          { pattern: checkPhone, message: '请输入正确的手机号' }
        ],
        psw: [
          { required: true, message: '请输入密码' },
          { pattern: checkPassword, message: '请输入8-20位非汉字密码' }
        ],
        paypsw: [
          { required: true, message: '请输入支付密码' },
          { pattern: /\d{6}/, message: '请输入6位数字支付密码' }
        ],
        power: [
          { required: true, message: '请选择权限' }
        ]
      },
      powers: [
        {
          label: '查看产品',
          value: 1
        },
        {
          label: '查看协议',
          value: 2
        },
        {
          label: '制作订单',
          value: 3
        },
        {
          label: '查看订单',
          value: 4
        },
        {
          label: '付款',
          value: 5
        },
        {
          label: '金额隐藏',
          value: 6
        },
        {
          label: '部门账户数据权限',
          value: 25
        }
      ],
      rootAccountList: []
    }
  },
  computed: {
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    },
    title () {
      return this.isEdit ? '编辑' : '新增'
    }
  },
  methods: {
    ...mapActions(['getRootAccount', 'getCustomerManagerDepartmentAccountList', 'addOrEditCustomerManagerDepartmentAccount']),
    handleClose () {
      this.$emit('update:show', false)
    },
    handleSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            childId: this.form.childAccountId ? this.form.childAccountId : '',
            childMobile: this.form.phone,
            mainAccountId: this.form.rootAccount && this.form.rootAccount.accountId,
            password: base64Text(this.form.psw),
            paymentPassword: base64Text(this.form.paypsw),
            resourceType: this.form.power,
            userName: this.form.username
          }
          this.addOrEditCustomerManagerDepartmentAccount(params).then(() => {
            this.$message.success('操作成功')
            this.handleClose()
            this.getCustomerManagerDepartmentAccountList()
          })
        } else {
          return false
        }
      })
    },
    powerChange (val) {
      // if (val.includes(6)) {
      //   this.$message.warning('该用户隐藏价格信息')
      // }
    },
    powerItemChange (item) {
      console.log(item)
      if (item.value === 6 && this.form.power.includes(6)) {
        this.$message.warning('该用户隐藏价格信息')
      }
    },
    // 获取主账号选项
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        const params = {
          accountType: 1,
          condition: query
        }
        this.getRootAccount(params).then(res => {
          this.loading = false
          this.rootAccountList = res
        })
      } else {
        this.rootAccountList = []
      }
    }
  },
  watch: {
    show (newVal) {
      this.visiable = newVal
      if (newVal) {
        if (this.isEdit) {
          this.form = { ...this.info }
        } else {
          this.form = {
            rootAccount: '',
            username: '',
            phone: '',
            psw: '',
            paypsw: '',
            power: []
          }
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-input, /deep/ .el-select {
  width: 200px;
}
</style>
